module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "卡详情信息",
      "visible": _vm.cardDetailVisible,
      "close-on-click-modal": false,
      "width": "60%"
    },
    on: {
      "update:visible": function($event) {
        _vm.cardDetailVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "cardDetail",
    attrs: {
      "label-width": "100px",
      "model": _vm.cardDetail
    }
  }, [_c('div', {
    staticStyle: {
      "overflow": "auto",
      "width": "100%"
    }
  }, [_c('table', {
    staticClass: "border-table"
  }, [_c('tr', [_c('td', {
    staticClass: "spec alt"
  }, [_vm._v("卡号：")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cardDetail.msisdn))]), _vm._v(" "), _c('td', {
    staticClass: "alt"
  }, [_vm._v("ICCID:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cardDetail.iccid))]), _vm._v(" "), _c('td', {
    staticClass: "alt"
  }, [_vm._v("IMSI:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cardDetail.imsi))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "spec alt"
  }, [_vm._v("用户状态：")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cardDetail.cardstate))]), _vm._v(" "), _c('td', {
    staticClass: "alt"
  }, [_vm._v("套餐名称：")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cardDetail.packname))]), _vm._v(" "), _c('td', {
    staticClass: "alt"
  }, [_vm._v("查询代码：")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cardDetail.querycode))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "spec alt"
  }, [_vm._v("工作状态：")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cardDetail.workstate))]), _vm._v(" "), _c('td', {
    staticClass: "alt"
  }, [_vm._v("开机状态：")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cardDetail.openstate))]), _vm._v(" "), _c('td', {
    staticClass: "alt"
  }, [_vm._v("API代码：")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cardDetail.apicode))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "spec alt"
  }, [_vm._v("是否签约短信服务：")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cardDetail.smssign))]), _vm._v(" "), _c('td', {
    staticClass: "alt"
  }, [_vm._v("是否签约GPRS:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cardDetail.gprssign))]), _vm._v(" "), _c('td', {
    staticClass: "alt"
  }, [_vm._v("用户余额：")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatCardBalance(_vm.cardDetail.balance)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "spec alt"
  }, [_vm._v("套餐总流量：")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatGprsVal(_vm.cardDetail.gprstotal, 'm')))]), _vm._v(" "), _c('td', {
    staticClass: "alt"
  }, [_vm._v("已用流量：")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatGprsVal(_vm.cardDetail.gprsused)))]), _vm._v(" "), _c('td', {
    staticClass: "alt"
  }, [_vm._v("剩余流量：")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatGprsVal(_vm.cardDetail.gprsnow)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "spec alt"
  }, [_vm._v("当月短信使用条数：")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cardDetail.smsmonthused) + "条")]), _vm._v(" "), _c('td', {
    staticClass: "alt"
  }, [_vm._v("服务商名称：")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cardDetail.servicername))]), _vm._v(" "), _c('td', {
    staticClass: "alt"
  }, [_vm._v("激活时间：")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cardDetail.activetime))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "spec alt"
  }, [_vm._v("APN：")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cardDetail.apn))]), _vm._v(" "), _c('td', {
    staticClass: "alt"
  }, [_vm._v("IP：")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cardDetail.ip))]), _vm._v(" "), _c('td', {
    staticClass: "alt"
  }, [_vm._v("接入类型：")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cardDetail.innettype))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "spec alt"
  }, [_vm._v("入库日期：")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cardDetail.inskutime))]), _vm._v(" "), _c('td', {
    staticClass: "alt"
  }, [_vm._v("出库日期：")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cardDetail.outskutime))]), _vm._v(" "), _c('td', {
    staticClass: "alt"
  }, [_vm._v("最后更新时间：")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cardDetail.lastsyntime))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "spec alt"
  }, [_vm._v("到期时间：")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cardDetail.expiretime))]), _vm._v(" "), _c('td', {
    staticClass: "alt"
  }, [_vm._v("开户时间：")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "alt"
    }
  }, [_vm._v(_vm._s(_vm.cardDetail.openAccountTime))]), _vm._v(" "), _c('td', {
    staticClass: "alt"
  }, [_vm._v("充值价格：")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cardDetail.rechargePrice) + "元")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "alt"
  }, [_vm._v("备注信息：")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.cardDetail.remark))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.cardDetailVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.queryLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateCard.apply(null, arguments)
      }
    }
  }, [_vm._v("手动更新")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-01d90a9c!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/card_info.vue
// module id = 721
// module chunks = 2